/**
 * Simula fila de jobs de geração de relatório (pending → success com download).
 */

import { registerDemoJob } from "./demoJobHistory";

/** PDF mínimo válido (base64) para o botão Baixar no demo. */
export const DEMO_REPORT_PDF_BASE64 =
  "JVBERi0xLjAKMSAwIG9iago8PAovVHlwZSAvQ2F0YWxvZwovUGFnZXMgMiAwIFIKPj4KZW5kb2JqCjIgMCBvYmoKPDwKL1R5cGUgL1BhZ2VzCi9LaWRzIFszIDAgUl0KL0NvdW50IDEKPD4KZW5kb2JqCjMgMCBvYmoKPDwKL1R5cGUgL1BhZ2UKL1BhcmVudCAyIDAgUgovTWVkaWFCb3ggWzAgMCA2MTIgNzkyXQo+PgplbmRvYmoKeHJlZgowIDQKMDAwMDAwMDAwMCA2NTUzNSBmIAowMDAwMDAwMDA5IDAwMDAwIG4gCjAwMDAwMDAwNTggMDAwMDAgbiAKMDAwMDAwMDExNSAwMDAwMCBuIAp0cmFpbGVyCjw8Ci9TaXplIDQKL1Jvb3QgMSAwIFIKPj4Kc3RhcnR4cmVmCjE3NQolJUVPRg==";

let phase = "idle";
let lastJob = null;

export function notifyDemoReportJobPosted(body) {
  if (!body) {
    return;
  }
  const reportName = body.name || body.fileName || "Relatório";
  const classId = body.classId || null;
  phase = "pending";
  lastJob = {
    id: `demo-report-job-${Date.now()}`,
    status: "pending",
    name: "generate_class_report",
    title: classId ? `Turma ${classId} | ${reportName}` : reportName,
    classId,
    fileName: reportName
  };
  registerDemoJob(lastJob);
}

export function takeDemoReportJobsResponse() {
  if (phase === "idle" || !lastJob) {
    return [];
  }
  if (phase === "pending") {
    phase = "await_success";
    registerDemoJob({ ...lastJob, status: "pending" });
    return [{ ...lastJob, status: "pending" }];
  }
  if (phase === "await_success") {
    const done = {
      ...lastJob,
      status: "success",
      download: {
        available: true,
        fileName: lastJob.fileName || "relatorio.pdf"
      }
    };
    registerDemoJob(done);
    phase = "idle";
    lastJob = null;
    return [done];
  }
  return [];
}

export function getDemoReportDownload(jobId) {
  return {
    fileName: "relatorio-demo.pdf",
    base64: DEMO_REPORT_PDF_BASE64,
    jobId
  };
}
